import script from "./MattersNewSelectCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MattersNewSelectCategory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__